export default __webpack_public_path__ + "static/media/galaxyTextureBW.3bf07a9f.png";